/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegistrationDataRouteImport } from './routes/registration-data'
import { Route as InvalidTokenRouteImport } from './routes/invalid-token'
import { Route as EmptyRegistrationDataRouteImport } from './routes/empty-registration-data'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PartnerLoginRouteImport } from './routes/partner/login'
import { Route as LoginHashRouteImport } from './routes/login.$hash'

const RegistrationDataRoute = RegistrationDataRouteImport.update({
  id: '/registration-data',
  path: '/registration-data',
  getParentRoute: () => rootRouteImport,
} as any)
const InvalidTokenRoute = InvalidTokenRouteImport.update({
  id: '/invalid-token',
  path: '/invalid-token',
  getParentRoute: () => rootRouteImport,
} as any)
const EmptyRegistrationDataRoute = EmptyRegistrationDataRouteImport.update({
  id: '/empty-registration-data',
  path: '/empty-registration-data',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerLoginRoute = PartnerLoginRouteImport.update({
  id: '/partner/login',
  path: '/partner/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginHashRoute = LoginHashRouteImport.update({
  id: '/login/$hash',
  path: '/login/$hash',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/empty-registration-data': typeof EmptyRegistrationDataRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/registration-data': typeof RegistrationDataRoute
  '/login/$hash': typeof LoginHashRoute
  '/partner/login': typeof PartnerLoginRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/empty-registration-data': typeof EmptyRegistrationDataRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/registration-data': typeof RegistrationDataRoute
  '/login/$hash': typeof LoginHashRoute
  '/partner/login': typeof PartnerLoginRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/empty-registration-data': typeof EmptyRegistrationDataRoute
  '/invalid-token': typeof InvalidTokenRoute
  '/registration-data': typeof RegistrationDataRoute
  '/login/$hash': typeof LoginHashRoute
  '/partner/login': typeof PartnerLoginRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/empty-registration-data'
    | '/invalid-token'
    | '/registration-data'
    | '/login/$hash'
    | '/partner/login'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/empty-registration-data'
    | '/invalid-token'
    | '/registration-data'
    | '/login/$hash'
    | '/partner/login'
  id:
    | '__root__'
    | '/'
    | '/empty-registration-data'
    | '/invalid-token'
    | '/registration-data'
    | '/login/$hash'
    | '/partner/login'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EmptyRegistrationDataRoute: typeof EmptyRegistrationDataRoute
  InvalidTokenRoute: typeof InvalidTokenRoute
  RegistrationDataRoute: typeof RegistrationDataRoute
  LoginHashRoute: typeof LoginHashRoute
  PartnerLoginRoute: typeof PartnerLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/registration-data': {
      id: '/registration-data'
      path: '/registration-data'
      fullPath: '/registration-data'
      preLoaderRoute: typeof RegistrationDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invalid-token': {
      id: '/invalid-token'
      path: '/invalid-token'
      fullPath: '/invalid-token'
      preLoaderRoute: typeof InvalidTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/empty-registration-data': {
      id: '/empty-registration-data'
      path: '/empty-registration-data'
      fullPath: '/empty-registration-data'
      preLoaderRoute: typeof EmptyRegistrationDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/login': {
      id: '/partner/login'
      path: '/partner/login'
      fullPath: '/partner/login'
      preLoaderRoute: typeof PartnerLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$hash': {
      id: '/login/$hash'
      path: '/login/$hash'
      fullPath: '/login/$hash'
      preLoaderRoute: typeof LoginHashRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EmptyRegistrationDataRoute: EmptyRegistrationDataRoute,
  InvalidTokenRoute: InvalidTokenRoute,
  RegistrationDataRoute: RegistrationDataRoute,
  LoginHashRoute: LoginHashRoute,
  PartnerLoginRoute: PartnerLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
